"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("./Dialog"));

/*
 * Confirmation dialog component to confirm or cancel an action
 */
var ConfirmationDialog = function ConfirmationDialog(props) {
  var content = props.content,
      onClickCancel = props.onClickCancel,
      cancelButtonText = props.cancelButtonText,
      onClickConfirm = props.onClickConfirm,
      confirmButtonText = props.confirmButtonText,
      disableConfirm = props.disableConfirm;

  var footer = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
    type: 'button',
    className: 'CancelButton btn btn-default',
    onClick: onClickCancel
  }, cancelButtonText), /*#__PURE__*/_react.default.createElement("button", {
    type: 'button',
    className: 'ConfirmationButton btn btn-primary',
    onClick: onClickConfirm,
    disabled: disableConfirm
  }, confirmButtonText));

  return /*#__PURE__*/_react.default.createElement(_Dialog.default, (0, _extends2.default)({}, props, {
    body: content,
    footer: footer,
    onHide: onClickCancel,
    showCloseButton: false,
    className: 'confirmation-dialog',
    disableEsc: true
  }));
};

ConfirmationDialog.defaultProps = {
  show: false,
  onClickCancel: function onClickCancel() {},
  onClickConfirm: function onClickConfirm() {}
};
ConfirmationDialog.propTypes = {
  show: _propTypes.default.bool.isRequired,
  title: _propTypes.default.node.isRequired,
  subtitle: _propTypes.default.node,
  content: _propTypes.default.node.isRequired,
  onClickCancel: _propTypes.default.func.isRequired,
  onClickConfirm: _propTypes.default.func.isRequired,
  cancelButtonText: _propTypes.default.node.isRequired,
  confirmButtonText: _propTypes.default.node.isRequired,
  disableConfirm: _propTypes.default.bool,
  bsSize: _propTypes.default.string
};
var _default = ConfirmationDialog;
exports.default = _default;